import React, { useState , useEffect , useContext } from "react";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import  { WebContext }  from "../../Webroute";
import {
  customalert,
  getUser,
  updateSession,
  filebasepath,
  loaderBar,
  errorToast,
  successToast,
  apibaseURl,
  alertDanger,
  changeDateFotmate,
  loggedInCustomerDetails,
  currencySymbol,
} from "../../functions/Function";
const Payment = (props) => {
  const WebData = useContext(WebContext);
  const [isloading, setisloading] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [inputs, setInputs] = useState({});
  const [user, setUser] = useState(false);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(apibaseURl + "paymentOptionAdded", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();
      setDisabled(false);
      if (res.status === 200) {
        setInputs({ user_id: loggedInCustomerDetails("id") });
        if (output.result == true) {
          WebData.updateUser();
          userdata();
          successToast("Payment details save successfully", "top-right", 3000, true);
        } else if (output.validation == true) {
          errorToast(
            getvalidationErr(output.response),
            "top-right",
            1500,
            true
          );
        } else {
          errorToast(output.response, "top-right", 3000, true);
        }
      }
    } catch (err) {
      setDisabled(false);
    }
  };

  const getvalidationErr = (errors) => {
    const errorsConvertInArry = Object.values(errors);
    let collectAllValidationErr = [];
    errorsConvertInArry.forEach((error, index) => {
      collectAllValidationErr.push(<div key={index}>{error}</div>);
    });
    const storeAllValidtionErr = <>{collectAllValidationErr}</>;

    errorToast(storeAllValidtionErr, "top-right", 3000, true);
  };
  const userdata = async () =>
   {
      var result =   await getUser();
      if(result.status == true)
      {
         setUser(result.response);
      }
    }

  useEffect(() => {
    updateSession('is_approved' , '1')
    userdata();
    setInputs({'user_id':loggedInCustomerDetails('id')})
 }, [])

  return (
    
    <>
     
      
      <ToastContainer />
      {user && ( user.payment_option.status == 'rejected' || user.payment_option.status == '') && 
        <form method="POST" onSubmit={handleSubmit}>
         
          <div className="account-right-content-shdow">
            <h5 className="account-tab-heading">Withdraw Payment Options</h5>
            {user.payment_option.note && customalert(user.payment_option.note , 'info') }
            <div className="">
              <h6>1. Bank Transfer</h6>
              <div className="mt-3">
                <div className="form-group contact-form">
                  <div className="form-detail-icons">
                    <label>Bank Name</label>
                    <input
                      type="text"
                      className="form-control my-form-control"
                      placeholder="XXXX XXXX XXX XXXX"
                      name="bank_name"
                      onChange={handleChange}
                      value={inputs.bank_name || ""}
                    />

                    <div className="form-icon">
                      <i className="fa-solid fa-building-columns"></i>
                    </div>
                  </div>
                  <p className="not-found-text ">
                    
                    <small id="emailHelp" className="form-text text-danger">
                      We'll never share your email with anyone else.
                    </small>
                  </p>
                </div>

                <div className="form-group contact-form">
                  <div className="form-detail-icons">
                    <label>Account NO.</label>
                    <input
                      type="text"
                      className="form-control my-form-control"
                      placeholder="XXXX XXXX XXX XXXX"
                      name="bank_account_no"
                      onChange={handleChange}
                      value={inputs.bank_account_no || ""}
                    />
                    <div className="form-icon">
                      <i className="fa-solid fa-hashtag"></i>
                    </div>
                  </div>
                  <p className="not-found-text ">
                    
                    <small id="emailHelp" className="form-text text-danger">
                      We'll never share your email with anyone else.
                    </small>
                  </p>
                </div>
              </div>
              <h6>2. Mobile Number</h6>
              <div className="form-group contact-form mt-4">
                <div className="form-detail-icons">
                  <label>Mobile Number</label>
                  <input
                    type="text"
                    className="form-control my-form-control"
                    placeholder="XXXX XXXX XXX XXXX"
                    name="mobile_no"
                    onChange={handleChange}
                    value={inputs.mobile_no || ""}
                  />
                  <div className="form-icon">
                    <i className="fa-solid fa-hashtag"></i>
                  </div>
                </div>
                <p className="not-found-text ">
                  {" "}
                  <small id="emailHelp" className="form-text text-danger">
                    We'll never share your email with anyone else.
                  </small>
                </p>
              </div>
            </div>
            <div className="text-center">
              <button
                className="btn ivo-site-btn inline-btn"
                type="submit"
                disabled={disabled}
              >
               
                {disabled == false ? "Submit" : "Submiting..."}{" "}
              </button>
            </div>
            </div>
        </form>
      }

      {user &&  (user.payment_option.status == 'accepted'|| user.payment_option.status == 'submited') && 
      <div className="account-right-content-shdow">
          <h5 className="account-tab-heading">Payment Options</h5>

            <div className="placeholderContainer">
              <h6>1. Bank Transfer</h6>
              <div className="PaymentPlaceholder">
                  <div className="mt-2 eachplaceholderpayment">
                    <p>Bank Name </p>
                    <p><label>{user.payment_option.option1.bank_name}</label></p>
                  </div>

                  <div className="eachplaceholderpayment">
                    <p>Account No. </p>
                    <p><label>{user.payment_option.option1.bank_account_no}</label></p>
                  </div>

                </div>
                
            </div>

            <div className="placeholderContainer">
              <h6>2. Mobile Number</h6>
              <div className="PaymentPlaceholder">
                  <div className="mt-2 eachplaceholderpayment">
                    <p>Mobile Number</p>
                    <p><label>{user.payment_option.option2.mobile_no}</label></p>
                  </div>


                </div>
                
            </div>
      </div>
      } 

    </>
  );
};

export default Payment;
